import {
  createAction,
  ObjectStore,
  on,
  RemoteCollectionDetailStore,
  RemoteCollectionStore,
  RemoteQueryStore,
  StoreBuilder
} from '@softline/core';
import {
  BeweAu,
  BewePr, KopfPr,
  ProduktionsauftragQueryResult,
  Rezept,
  Rezeptliste,
  Zusatzdaten
} from '../types/produktionsauftrag';
import {UpdateRezepturBeweParams} from '../types/update-rezeptur-bewe-params';
import {RezepturBeweService} from '../services/rezeptur-bewe.service';
import {firstValueFrom} from 'rxjs';
import {
  SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE,
  SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_QUERY
} from '../produktionsauftrag.shared';
import {KopfprService} from '../services/kopfpr.service';

export const ProduktionsauftragStore =
  new StoreBuilder(RemoteCollectionStore.create<ProduktionsauftragQueryResult>())
  .add(RemoteQueryStore.create<object>())
  .value;


const BewePrRemoteCollectionStore = RemoteCollectionStore.create<BewePr>()
const BewePrDetailStore = RemoteCollectionDetailStore.create<BewePr, {rezeptliste: Rezeptliste, zusatzdaten: Zusatzdaten}>()

const actions = {
  updateRezepturBewe: createAction<RemoteCollectionStore.State, { rezept: Rezept, bewepr: BewePr, params: UpdateRezepturBeweParams }, Rezeptliste>('produktionsauftrag/bewepr/actions/updateRezepturBewe'),
  updateStatus: createAction<RemoteCollectionStore.State, { id: number, bewepr: BewePr, status: string  }, BewePr>('produktionsauftrag/bewepr/actions/updateStatus'),
}

const BewePrStoreExtension = {
  actions,
  feature: {
    mutations: [],
    getters: [],
    actions: [
      on(actions.updateRezepturBewe, async ({ featureName, params, get, commit, injector }) => {
        const service = injector.get(RezepturBeweService);

        const result = await firstValueFrom(service.update(params.params));

        commit(featureName, BewePrDetailStore.mutations.patchDetail, {
          name: SOFTLINE_CONST_PRODUKTIONSAUFTRAG_REZEPTLISTE as never,
          id: params.bewepr.id,
          value: result
        });

        return result;
      }),
      on(actions.updateStatus, async ({ featureName, params, get, commit, injector }) => {
        const service = injector.get(KopfprService);
        const result = await firstValueFrom(service.updateStatus({ kopfpr: params.bewepr.kopfprBean, status: params.status }));

        commit(featureName, BewePrStore.mutations.patch, {
          id: params.id,
          changes: {
            kopfprBean: {
              ...params.bewepr.kopfprBean,
              ...result
            },
          }
        });

        if (get(SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_QUERY, ProduktionsauftragStore.getters.entity, params.id)) {
          commit(SOFTLINE_FEATURE_PRODUKTIONSAUFTRAG_QUERY, ProduktionsauftragStore.mutations.patch, {
            id: params.id + '',
            changes: {
              bewepr: {
                ...params.bewepr,
                kopfprBean: result
              }
            }
          });
        }

        return result;
      })
    ],
  }
}

export const BewePrStore =
  new StoreBuilder(BewePrRemoteCollectionStore)
    .add(BewePrDetailStore)
    .add(BewePrStoreExtension)
    .value;

export const BeweAuStore =
  new StoreBuilder(RemoteCollectionStore.create<BeweAu>())
    .value;

export const FilterStore = ObjectStore.create<{filter: object, isExpanded: boolean}>()
